import script from "./UiChoiceCards.vue?vue&type=script&setup=true&lang=js"
export * from "./UiChoiceCards.vue?vue&type=script&setup=true&lang=js"

import "./UiChoiceCards.vue?vue&type=style&index=0&id=467c59e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-467c59e0"]])

export default __exports__